module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo5-35b568ffb34653adcf63ce31d1c76dee.jpg";